import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";

interface BankOfferProps {
  projectData: {
    bankOffers: { _id: string; bankName: string; bankIcon: string }[];
  };
}

const BankOffers: React.FC<BankOfferProps> = ({ projectData }) => {
  const { bankOffers } = projectData;

  const scrollingList =
    bankOffers.length > 1 ? [...bankOffers, ...bankOffers] : bankOffers;

  return (
    <Box
      sx={{
        overflow: "hidden",
        whiteSpace: "nowrap",
        position: "relative",
        width: { xs: "90%", md: "94.9%" },
        backgroundColor: "#f9f9f9",
        padding: "20px",
        borderRadius: "10px",
        border: "1px solid #ddd",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography variant="h6" gutterBottom>
        Bank Offers
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: "20px",
          width: "max-content",
          ...(bankOffers.length > 1 && {
            animation: "scrollLeft 15s linear infinite",
            "@keyframes scrollLeft": {
              "0%": { transform: "translateX(0)" },
              "100%": { transform: "translateX(-50%)" },
            },
          }),
        }}
      >
        {scrollingList.map((bank, index) => (
          <Card
            key={index}
            sx={{
              width: { xs: "180px", md: "300px" },
              height: { xs: "60px", md: "100px" },
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px",
              backgroundColor: "#fff",
              borderRadius: "10px",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.4)",
              flexShrink: 0,
            }}
          >
            {/* Left box for bank image */}
            <Box sx={{ display: "flex", alignItems: "center", padding: "5px" }}>
              <img
                src={`${
                  process.env.NEXT_PUBLIC_STORAGE_DN_URL ||
                  "https://dprstorage.b-cdn.net"
                }${bank.bankIcon}`}
                alt={`${bank.bankName} logo`}
                style={{ width: "auto", height: "50px" }}
              />
            </Box>

            {/* Right content with bank name */}
            <CardContent sx={{ textAlign: "left" }}>
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                {bank.bankName}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default BankOffers;
